import { gql } from '@apollo/client';

export const DeleteDefinitionPage = gql`
mutation DeleteDefinitionPage($deleteDefinitionPageId: ID!) {
  deleteDefinitionPage(id: $deleteDefinitionPageId) {
    status
  }
}
`;